<template>
    <div class="page-users page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="24">
                    <h3 style="float: none;">企业下单申请</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>合作申请</el-breadcrumb-item>
                            <el-breadcrumb-item>企业下单申请</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
            </el-row>
            <div class="bd">
               <!-- <div class="search-block content-body">
                    <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline" @submit.native.prevent>
                        <el-form-item prop="name" label="客户姓名：" style="margin-bottom: 0;">
                            <el-input v-model="form_search.name" size="small" placeholder="用户昵称" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="mobile" label="客户手机号：">
                            <el-input v-model="form_search.mobile" type='number' size="small" placeholder="用户手机号" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="user_number" label="用户编码：">
                            <el-input v-model="form_search.user_number" size="small" placeholder="请输入用户ID" clearable></el-input>
                        </el-form-item>
                        <el-form-item style="margin-bottom: 0;">
                            <el-button type="primary" class="search-btn"  size="medium" @click='searchList()'>查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>-->
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;">
                            <el-table-column prop="name" align="center" label="企业名称" min-width="180">
                                <template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.name"></my-textEllipsis>
                                </template>
                            </el-table-column>
                            <el-table-column prop="contact" align="center" label="企业联系人" min-width="120">
                            </el-table-column>
                            <el-table-column prop="contact_phone" align="center" label="联系方式" min-width="120">
                            </el-table-column>
                            <el-table-column prop="order_count" align="center" label="预估用餐人数" min-width="180">
                            </el-table-column>
                            <el-table-column prop="detailed" align="center" label="企业地址" min-width="180">
                            </el-table-column>
                            <el-table-column prop="c_time" align="center" label="申请时间" min-width="180">
                            </el-table-column>
                            <el-table-column prop="status_name" align="center" label="状态" min-width="120">
                                <template slot-scope="scope">
                                    <span :class="'status-'+scope.row.status">{{scope.row.status_name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="operating" align="center" label="操作" min-width="140" fixed="right">
                                <template slot-scope="scope">
                                    <el-button v-if="scope.row.status==0" class="option-btn btn-bd-s" type="primary" size="mini" @click="dealApply(scope.row.id)">处理申请</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="table_data.page_info.page"
                            :page-sizes="[10,30, 50,80,100]"
                            :page-size="table_data.page_info.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="table_data.page_info.total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'usercenter',
        data() {
            return {
                clientHeight:'',
                body_loading:false,
                is_refresh: true,
                form_search:{
                    //user_number:'',
                    //mobile:"",
                    //name:''
                    type:1
                },
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        page: 1,
                        pageSize: 30,
                        total: 130
                    }
                }
            }
        },
        created() {
            document.title = '企业下单申请';
            this.getList();
        },
        methods: {
            searchList(){
                var _this = this;
                _this.table_data.page_info.page = 1;
                _this.getList();
            },
            getList() {
                var _this = this;
                var params = _this.form_search;
                params.p = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                _this.table_data.loading = true;
                this.$client.get('/adminapi/cooperationapply/list', params, function(res,message){
                    _this.table_data.list = res.list;
                    _this.table_data.page_info = res.pager;
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
                this.table_data.page_info.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.table_data.page_info.page = val;
                this.getList();
            },
            dealApply(id){
                var _this = this;
                var params = {
                    id:id,
                    type:1
                };
                _this.$client.post('/adminapi/cooperationapply/dealcooperationapply', params, function(res,message){
                    _this.$message(message);
                    _this.getList();
                }, function(res){
                    //_this.getCaptcha();
                });
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            }
        }
    }
</script>
<style>

</style>
<style scoped>

</style>